export const checkStripe = (successAllow=()=> {}, errorCallback=(response)=>{window.location.href = response.responseJSON.redirect}) => {
    $.ajax({
        url: '/stripe-check',
        success: successAllow,
        error: errorCallback
    });
}
